
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ifloorplan/[id]",
      function () {
        return require("private-next-pages/ifloorplan/[id].js");
      }
    ]);
  